import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Divider, Typography } from '@telus-uds/components-web';

import BCON from './bcon';

const ManageProducts = () => {
  const [tabSelected, setTabSelected] = useState('BCON');

  return (
    <div className="container 85%" style={{ padding: '2rem' }}>
      <Typography heading="h2" variant={{ size: 'h2' }} block>Manage Products</Typography>
      <div
        style={{
          marginTop: '2rem',
          borderBottom: '1px solid #e4e4e4',
          padding: '0 2rem'
        }}
      >
        <ul
          style={{
            display: 'flex',
            gap: '2rem'
          }}
        >
          <li
            style={{
              padding: '1rem 2rem',
              borderRadius: '6px 6px 0 0',
              background:
                tabSelected === 'BCON' ? '#4b286d' : '#ffffff',
              border:
                tabSelected === 'BCON'
                  ? '2px solid #4b286d'
                  : '1px solid #e4e4e4',
              borderBottom: 0,
              color: tabSelected === 'BCON' ? '#ffffff' : '#454545',
              fontWeight: tabSelected === 'BCON' ? '500' : '400',
              cursor: 'pointer'
            }}
            onClick={() => setTabSelected('BCON')}
          >
            BCON
          </li>
        </ul>
      </div>
      <Divider space={1} variant={{ inverse: true }} />
      {tabSelected === 'BCON' && <BCON />}
    </div>
  );
};

export default ManageProducts;
